/**
 * Default objects for user and product migration.
 */
import {
  DEFAULT_USER_LOCATION,
  DEFAULT_USER_BUSINESS_INFO,
  DEFAULT_USER_SOCIAL_LINKS,
  DEFAULT_USER_PRIVACY_SETTINGS,
  DEFAULT_PRODUCT_LOCATION,
  DEFAULT_PRODUCT_DELIVERY,
  DEFAULT_PRODUCT_WARRANTY,
  DEFAULT_PRODUCT_STATS,
} from '../schema';

export const USER_DEFAULTS = {
  alternatePhone: '',
  dateOfBirth: null,
  gender: '',
  coverPhoto: '',
  about: '',
  languages: '',
  website: '',
  location: DEFAULT_USER_LOCATION(),
  businessInfo: DEFAULT_USER_BUSINESS_INFO(),
  socialLinks: DEFAULT_USER_SOCIAL_LINKS(),
  emailVerified: false,
  phoneVerified: false,
  idVerified: false,
  addressVerified: false,
  kycStatus: 'not_started',
  trustScore: 0,
  badgeLevel: 'new',
  responseRate: 0,
  responseTime: '',
  totalAdsPosted: 0,
  totalAdsSold: 0,
  totalActiveAds: 0,
  followersCount: 0,
  followingCount: 0,
  accountStatus: 'active',
  role: 'user',
  isOnline: false,
  lastSeen: null,
  premiumMember: false,
  premiumExpiry: null,
  referralCode: '',
  referredBy: '',
  preferredLanguage: 'en',
  currency: 'EUR',
  privacySettings: DEFAULT_USER_PRIVACY_SETTINGS(),
  savedAds: [],
  watchlist: [],
  updatedAt: null,
};

export const PRODUCT_DEFAULTS = {
  slug: '',
  originalLanguage: '',
  translations: {},
  tags: [],
  originalPrice: null,
  discountPercentage: null,
  priceCurrency: 'EUR',
  priceType: 'fixed',
  adType: 'for_sale',
  thumbnailUrl: '',
  videoUrl: '',
  sellerName: '',
  sellerAvatar: '',
  sellerVerified: false,
  sellerBadgeLevel: 'new',
  contactPreference: 'both',
  location: DEFAULT_PRODUCT_LOCATION(),
  delivery: DEFAULT_PRODUCT_DELIVERY(),
  warranty: DEFAULT_PRODUCT_WARRANTY(),
  returnPolicy: 'no_returns',
  paymentMethods: [],
  isFeatured: false,
  isUrgent: false,
  isPromoted: false,
  promotionPlan: 'none',
  promotionExpiry: null,
  featuredUntil: null,
  marketingScore: 0,
  bumpedAt: null,
  moderationStatus: 'approved',
  moderationNote: '',
  rejectionReason: '',
  reportCount: 0,
  flaggedAt: null,
  stats: DEFAULT_PRODUCT_STATS(),
  watchers: {},
  seoTitle: '',
  seoDescription: '',
  searchKeywords: [],
  availableFrom: null,
  expiresAt: null,
  autoRenew: false,
  renewalCount: 0,
  lastRenewedAt: null,
  publishedAt: null,
  soldAt: null,
  soldTo: '',
  soldPrice: null,
  draftSavedAt: null,
  updatedAt: null,
};
